import uiReducer from "./uiReducer";
import userReducer from "./userReducer";
import databaseReducer from "./databaseReducer";
import { combineReducers } from "redux";

const appReducer = combineReducers({
  ui: uiReducer,
  userState: userReducer,
  database: databaseReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "CLEAR_SESSION") {
    const resetState = appReducer(undefined, { type: "@@INIT" });

    return {
      ...resetState,
      ui: {
        ...resetState.ui,
        theme: state && state.ui ? state.ui.theme : resetState.ui.theme,
      },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
